module.exports = __webpack_public_path__ + "static/media/karir-section-1-bg.9dc5af75.svg";